// import 'babel-polyfill'

import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'es6-promise/auto'
import Shared from '@shared'
import {
  getCookie,
  setCookie
} from '@shared/utils/helpers'
import { mapState, mapActions } from 'vuex'
import store from '@shared/store'
import Calendar from '@calendar'
import PersonalData from '@shared/components/PersonalData'
import Poll from '@shared/components/poll/Start.vue'

import { productsService } from '@shared/services/products'
import { stagesService } from '@shared/services/stages'
import { preloaderService } from '@shared/services/preloader'

import VueI18n from 'vue-i18n'
Vue.use(Shared)
Vue.use(Calendar)
Vue.use(VueAwesomeSwiper)

import VeeValidate, { Validator } from 'vee-validate'

Vue.prototype.getFromGlob = function(key) {
  return window._vueGlobData[key]
}
//filters
let zero = 0
Vue.filter('truncate', function (text, stop, clamp) {
  return text.slice(zero, stop) + (stop < text.length ? clamp || '...' : '')
})

Vue.use(VueI18n)
//i18n
Vue.prototype._ = function () {
  return this.$t.apply(this, arguments)
}
const phoneRule = {
  getMessage(field) {
    return "Your phone number is not valid."
  },
  validate(value) {

    // Custom regex for a phone number 
    const MOBILEREG = /^\+38\(0[+()\d-\s]+$/
    // Check for either of these to return true
    return MOBILEREG.test(value)
  }
}
VeeValidate.Validator.extend('phone', phoneRule)


const locale = document.documentElement.lang
//config to vee-validate
const config = {
  // dictionary: null,
  // i18n: i18n, // the vue-i18n plugin instance
  // i18nRootKey: 'validations',
  locale: locale
}


let dictionary = {
  "en": {
    "messages": {
      "required": "This field is required",
      "email": "Enter valid e-mail",
      "decimal": "Enter the correct number",
      'alpha': 'Only letters',
      'alpha_spaces': 'Only letters',
      'min': 'Enter at least 2 characters',
      'max': 'Value is too large'
    }
  },
  "uk": {
    "messages": {
      "required": "Поле обов`язкове до заповнення",
      "email": "Будь ласка введiть валiдний адрес пошти",
      "decimal": "Введiть коректне число",
      "phone": "Введiть правильний номер",
      'alpha': 'Тiльки лiтери',
      'alpha_spaces': 'Тiльки лiтери',
      'min': 'Введiть мiнiмум 2 символи ',
      'max': 'Введене значення задовге',
      'thankYou': 'Дякуємо, ваше питання відправлено!'
    }
  },
  "ru": {
    "messages": {
      "required": "Обязательное поле",
      "email": "Введите валидный email",
      "phone": "Введите правильний номер",
      "decimal": "Введите корректное число",
      'alpha': 'Только буквы',
      'alpha_spaces': 'Только буквы',
      'min': 'Введите минимум 2 символа ',
      'max': 'Введенное значение превышает лимит',
      'thankYou': 'Спасибо, ваш вопрос отправлен!'
    }
  },
}
const validator = new Validator()
validator.localize(locale, dictionary[locale])

const messages = {
  current: window.django.catalog || {}
}
export const i18n = new VueI18n({
  locale: 'current',
  messages: messages,
  silentTranslationWarn: true
})
Vue.use(VeeValidate, config)

window.app = new Vue({
  el: '#app',
  delimiters: ['[[', ']]'],
  store,
  i18n,

  provide: {
    productsService,
    stagesService,
    preloaderService,
  },

  // inject: ['preloaderService'],

  data() {
    return {
      isLoading: true,
      showTutorial: false,
      user_email: window.user_email,
      user_phone: window.user_phone,
    }
  },
  computed: {
    ...mapState('search', [
      'show_overlay',
      'active_search'
    ]),
  },
  mounted() {
    this.$on('startTutorial', (data) => {
      this.showTutorial = data
    })
    preloaderService.$on('preloadingFinished', e => {
      this.isLoading = false
    })
    let timeout = 20000
    setTimeout(() => {
      this.checkCookie()
      // this.checkPollCookie()
    }, timeout)
    
    if (!window.authent) return
    if (!this.user_email || !this.user_phone) {
      this.openPopup()
    }
    
  },
  created() {
    this.$store.dispatch('user/INIT')

  },
  methods: {
    ...mapActions('search', [
      'trigger_overlay'
    ]),
    rmChecked() {
      document.getElementById("menu-toggle").checked = false
    },
    checkCookie() {
      let show = getCookie('show_cookie')
      if (show) return
      this.openGame()
      setCookie('show_cookie', true)
    },
    checkPollCookie() {
      let show = getCookie('show_poll')
      if (show) return
      this.openPoll()
      setCookie('show_poll', true)
    },
    openPoll() {
      this.$modal.show(Poll, 
      {
        classes: this.classes,
      }, {
        height: 'auto',
        name: 'Poll',
        minWidth: 300,
        clickToClose: false,
        maxWidth: 370,
        adaptive: true,
        classes: ['transparent-modal', 'large-modal'],
        scrollable: true
      })
    },
    openPopup() {
      this.$modal.show(PersonalData, 
      {
        classes: this.classes,
      }, {
        height: 'auto',
        name: 'PersonalData',
        minWidth: 300,
        maxWidth: 370,
        adaptive: true,
        classes: 'transparent-modal',
        scrollable: true
      })
    },
    openGame() {
      this.$modal.show({
        template: `
          <div>
            <iframe src='/static/animation/index.html' width="300" height="600"></iframe>
            <a class="close-popup" @click.prevent='$emit("close")'> &times; </a>
          </div>
        `
      }, 
      {
        classes: this.classes,
      }, {
        height: 'auto',
        name: 'PersonalData',
        width: 300,
        height: 600,
        adaptive: true,
        scrollable: true
      })
    },
    showBubble() {
      let text = dictionary[locale].messages.thankYou
      this.$modal.show(
        {
          template: `
            <div class="modal is-opened is-trans">
              <div>${text}</div>
              <a class="close-popup" @click.prevent='$emit("close")'> &times; </a>
            </div>
          `
        }, 
        {
          class: ['bubble'],
        },  
        {
          height: 'auto',
          maxWidth: 400,
          adaptive: true
        }, {
          'opened': e => {
            setTimeout(() => {window.location.reload();}, 5000)
          },
          'closed': e => {
            window.location.reload();
          }
        })
    }

  },
})

let phoneInput = $('#question_phone')
function phoneMask(e) {
  let ph = e.currentTarget
  ph.value = ph.value.slice(0, 13);
  ph.value = ph.value.replace(/[^\d|\+]/g, '')
}
phoneInput.on('keyup', phoneMask)

function addError(el, msg) {
  console.log(msg)
  el.prev().text(msg)
}

let checked = false;
$("#question_agree").on('click', () => {
  checked = !checked;
})

$(document).ready(function(){
  $('#send_question').click(function () {
    $('.error-message').text('')

    var name = $("#question_name")
    var email = $("#question_email")
    var phone = $("#question_phone")
    var text = $("#question_text")
    var agree = $("#question_agree")

    name.removeClass("orange-error")
    email.removeClass("orange-error")
    phone.removeClass("orange-error")
    text.removeClass("orange-error")
    agree.removeClass("orange-error")

    if (name.val().length <= 0) {
      name.addClass("orange-error")
      let errorMsg = '';
      switch (config.locale) {
        case 'uk':
          errorMsg = 'Поле не може бути порожнiм'
          break
        case 'ru':
          errorMsg = 'Поле не может быть пустым'
          break
      }
      addError(name, errorMsg)
    }

    if (email.val().length <= 0) {
      email.addClass("orange-error")
      let emailErrorMsg = ''
      switch (config.locale) {
        case 'uk':
          emailErrorMsg = 'Поле не може бути порожнiм'
          break
        case 'ru':
          emailErrorMsg = 'Поле не может быть пустым'
          break
      }
      addError(email, emailErrorMsg)
    } else {
      var emailre = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if(!email.val().match(emailre)) {
        let emailErrorMsg = ''
        switch (config.locale) {
          case 'uk':
            emailErrorMsg = 'Введiть корректний емайл'
            break
          case 'ru':
            emailErrorMsg = 'Введите корректный email'
            break
        }
        addError(email, emailErrorMsg)
        email.addClass("orange-error")
      }
    }

    if (phone.val().length <= 0) {
      phone.addClass("orange-error")
    } else {
      var phoneno = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
      if(!phone.val().match(phoneno)) {
        phone.addClass("orange-error")
        let phoneErrorMsg = ''
        switch (config.locale) {
          case 'uk':
            phoneErrorMsg = 'Номер телефону не корректний'
            break
          case 'ru':
            phoneErrorMsg = 'Неправильно указан номер телефона'
            break
        }
        addError(phone, phoneErrorMsg)
      }
    }

    if (text.val().length <= 0) {
      text.addClass("orange-error")
      let textErrorMsg = ''
      switch (config.locale) {
        case 'uk':
          textErrorMsg = 'Поле не може бути порожнiм'
          break
        case 'ru':
          textErrorMsg = 'Поле не может быть пустым'
          break
      }
      addError(text, textErrorMsg)
    }

    if (!checked) {
      agree.addClass("error")
    } else {
      agree.removeClass("error")
    }

    $.ajax({
      type: 'POST',
      headers: {
          'Content-Type':'application/json; charset=utf-8'
      },
      cache: false,
      url: "https://com.nutricia.ua/v1/api/send-feedback/?api_key=aa541f44-ac6a-4fdb-b727-df36cc3bb04c",
      data: JSON.stringify({
        "topic": 11,
        "question": $("#question_text").val(),
        "email": $("#question_email").val(),
        "name":$("#question_name").val(),
        "phone": $("#question_phone").val(),
        "callback_by": "email"
      }),
      success: function () {
        $('#add').val('data sent sent');
        $('#success').click();
      },
      error: function (e) {
        console.log(e)
      }
      
    });

    return false;
  });

  $('.home__more').on('click', function(){
      var elementClick = $(this);
      var destination = elementClick.offset().top;
        $("html:not(:animated),body:not(:animated)").animate({
            scrollTop: destination
        }, 500);
  });
  $('.js--show-text').on('click', function (){
      $('.more').slideDown();
      $('.js--hide-text').show();
      $(this).hide();
  });
  $('.js--hide-text').on('click', function (){
      $('.more').slideUp();
      $('.js--show-text').show();
      $(this).hide();
  });
  function windowSize(){
    var viewportHeight = $(window).height();
        $('.home').css({ height: viewportHeight });
  }
  windowSize();
  $(window).resize(windowSize);
  if ($(window).width() < 960) {
    $(".home").on("touchmove", false);
  }
});
// //parallax
// (function(jQuery, undefined) {
//   // VAR
//   var debug = true,

//       options = {
//         mouseport:     'body',  // jQuery object or selector of DOM node to use as mouseport
//         xparallax:     true,    // boolean | 0-1 | 'npx' | 'n%'
//         yparallax:     true,    //
//         xorigin:       0.5,     // 0-1 - Sets default alignment. Only has effect when parallax values are something other than 1 (or true, or '100%')
//         yorigin:       0.5,     //
//         decay:         0.66,    // 0-1 (0 instant, 1 forever) - Sets rate of decay curve for catching up with target mouse position
//         frameDuration: 30,      // Int (milliseconds)
//         freezeClass:   'freeze' // String - Class added to layer when frozen
//       },

//       value = {
//         left: 0,
//         top: 0,
//         middle: 0.5,
//         center: 0.5,
//         right: 1,
//         bottom: 1
//       },

//       rpx = /^\d+\s?px$/,
//       rpercent = /^\d+\s?%$/,

//       win = jQuery(window),
//       doc = jQuery(document),
//       mouse = [0, 0];

//   var Timer = (function(){
//     var debug = false;

//     // Shim for requestAnimationFrame, falling back to timer. See:
//     // see http://paulirish.com/2011/requestanimationframe-for-smart-animating/
//     var requestFrame = (function(){
//           return (
//             window.requestAnimationFrame ||
//             window.webkitRequestAnimationFrame ||
//             window.mozRequestAnimationFrame ||
//             window.oRequestAnimationFrame ||
//             window.msRequestAnimationFrame ||
//             function(fn, node){
//               return window.setTimeout(function(){
//                 fn();
//               }, 25);
//             }
//           );
//         })();

//     function Timer() {
//       var callbacks = [],
//         nextFrame;

//       function noop() {}

//       function frame(){
//         var cbs = callbacks.slice(0),
//             l = cbs.length,
//             i = -1;

//         if (debug) { console.log('timer frame()', l); }

//         while(++i < l) { cbs[i].call(this); }
//         requestFrame(nextFrame);
//       }

//       function start() {
//         if (debug) { console.log('timer start()'); }
//         this.start = noop;
//         this.stop = stop;
//         nextFrame = frame;
//         requestFrame(nextFrame);
//       }

//       function stop() {
//         if (debug) { console.log('timer stop()'); }
//         this.start = start;
//         this.stop = noop;
//         nextFrame = noop;
//       }

//       this.callbacks = callbacks;
//       this.start = start;
//       this.stop = stop;
//     }

//     Timer.prototype = {
//       add: function(fn) {
//         var callbacks = this.callbacks,
//             l = callbacks.length;

//         // Check to see if this callback is already in the list.
//         // Don't add it twice.
//         while (l--) {
//           if (callbacks[l] === fn) { return; }
//         }

//         this.callbacks.push(fn);
//         if (debug) { console.log('timer add()', this.callbacks.length); }
//       },

//       remove: function(fn) {
//         var callbacks = this.callbacks,
//             l = callbacks.length;

//         // Remove all instances of this callback.
//         while (l--) {
//           if (callbacks[l] === fn) { callbacks.splice(l, 1); }
//         }

//         if (debug) { console.log('timer remove()', this.callbacks.length); }

//         if (callbacks.length === 0) { this.stop(); }
//       }
//     };

//     return Timer;
//   })();

//   function parseCoord(x) {
//     return (rpercent.exec(x)) ? parseFloat(x)/100 : x;
//   }

//   function parseBool(x) {
//     return typeof x === "boolean" ? x : !!( parseFloat(x) ) ;
//   }

//   function portData(port) {
//     var events = {
//           'mouseenter.parallax': mouseenter,
//           'mouseleave.parallax': mouseleave
//         },
//         winEvents = {
//           'resize.parallax': resize
//         },
//         data = {
//           elem: port,
//           events: events,
//           winEvents: winEvents,
//           timer: new Timer()
//         },
//         layers, size, offset;

//     function updatePointer() {
//       data.pointer = getPointer(mouse, [true, true], offset, size);
//     }

//     function resize() {
//       size = getSize(port);
//       offset = getOffset(port);
//       data.threshold = getThreshold(size);
//     }

//     function mouseenter() {
//       data.timer.add(updatePointer);
//     }

//     function mouseleave(e) {
//       data.timer.remove(updatePointer);
//       data.pointer = getPointer([e.pageX, e.pageY], [true, true], offset, size);
//     }

//     win.on(winEvents);
//     port.on(events);

//     resize();

//     return data;
//   }

//   function getData(elem, name, fn) {
//     var data = elem.data(name);

//     if (!data) {
//       data = fn ? fn(elem) : {} ;
//       elem.data(name, data);
//     }

//     return data;
//   }

//   function getPointer(mouse, parallax, offset, size){
//     var pointer = [],
//         x = 2;

//     while (x--) {
//       pointer[x] = (mouse[x] - offset[x]) / size[x] ;
//       pointer[x] = pointer[x] < 0 ? 0 : pointer[x] > 1 ? 1 : pointer[x] ;
//     }

//     return pointer;
//   }

//   function getSize(elem) {
//     return [elem.width(), elem.height()];
//   }

//   function getOffset(elem) {
//     var offset = elem.offset() || {left: 0, top: 0},
//       borderLeft = elem.css('borderLeftStyle') === 'none' ? 0 : parseInt(elem.css('borderLeftWidth'), 10),
//       borderTop = elem.css('borderTopStyle') === 'none' ? 0 : parseInt(elem.css('borderTopWidth'), 10),
//       paddingLeft = parseInt(elem.css('paddingLeft'), 10),
//       paddingTop = parseInt(elem.css('paddingTop'), 10);

//     return [offset.left + borderLeft + paddingLeft, offset.top + borderTop + paddingTop];
//   }

//   function getThreshold(size) {
//     return [1/size[0], 1/size[1]];
//   }

//   function layerSize(elem, x, y) {
//     return [x || elem.outerWidth(), y || elem.outerHeight()];
//   }

//   function layerOrigin(xo, yo) {
//     var o = [xo, yo],
//       i = 2,
//       origin = [];

//     while (i--) {
//       origin[i] = typeof o[i] === 'string' ?
//         o[i] === undefined ?
//           1 :
//           value[origin[i]] || parseCoord(origin[i]) :
//         o[i] ;
//     }

//     return origin;
//   }

//   function layerPx(xp, yp) {
//     return [rpx.test(xp), rpx.test(yp)];
//   }

//   function layerParallax(xp, yp, px) {
//     var p = [xp, yp],
//         i = 2,
//         parallax = [];

//     while (i--) {
//       parallax[i] = px[i] ?
//         parseInt(p[i], 10) :
//         parallax[i] = p[i] === true ? 1 : parseCoord(p[i]) ;
//     }

//     return parallax;
//   }

//   function layerOffset(parallax, px, origin, size) {
//     var i = 2,
//         offset = [];

//     while (i--) {
//       offset[i] = px[i] ?
//         origin[i] * (size[i] - parallax[i]) :
//         parallax[i] ? origin[i] * ( 1 - parallax[i] ) : 0 ;
//     }

//     return offset;
//   }

//   function layerPosition(px, origin) {
//     var i = 2,
//         position = [];

//     while (i--) {
//       if (px[i]) {
//         // Set css position constant
//         position[i] = origin[i] * 100 + '%';
//       }
//       else {

//       }
//     }

//     return position;
//   }

//   function layerPointer(elem, parallax, px, offset, size) {
//     var viewport = elem.offsetParent(),
//       pos = elem.position(),
//       position = [],
//       pointer = [],
//       i = 2;

//     // Reverse calculate ratio from elem's current position
//     while (i--) {
//       position[i] = px[i] ?
//         // TODO: reverse calculation for pixel case
//         0 :
//         pos[i === 0 ? 'left' : 'top'] / (viewport[i === 0 ? 'outerWidth' : 'outerHeight']() - size[i]) ;

//       pointer[i] = (position[i] - offset[i]) / parallax[i] ;
//     }

//     return pointer;
//   }

//   function layerCss(parallax, px, offset, size, position, pointer) {
//     var pos = [],
//         cssPosition,
//         cssMargin,
//         x = 2,
//         css = {};

//     while (x--) {
//       if (parallax[x]) {
//         pos[x] = parallax[x] * pointer[x] + offset[x];

//         // We're working in pixels
//         if (px[x]) {
//           cssPosition = position[x];
//           cssMargin = pos[x] * -1;
//         }
//         // We're working by ratio
//         else {
//           cssPosition = pos[x] * 100 + '%';
//           cssMargin = pos[x] * size[x] * -1;
//         }

//         // Fill in css object
//         if (x === 0) {
//           css.left = cssPosition;
//           css.marginLeft = cssMargin;
//         }
//         else {
//           css.top = cssPosition;
//           css.marginTop = cssMargin;
//         }
//       }
//     }

//     return css;
//   }

//   function pointerOffTarget(targetPointer, prevPointer, threshold, decay, parallax, targetFn, updateFn) {
//     var pointer, x;

//     if ((!parallax[0] || Math.abs(targetPointer[0] - prevPointer[0]) < threshold[0]) &&
//         (!parallax[1] || Math.abs(targetPointer[1] - prevPointer[1]) < threshold[1])) {
//         // Pointer has hit the target
//         if (targetFn) { targetFn(); }
//         return updateFn(targetPointer);
//     }

//     // Pointer is nowhere near the target
//     pointer = [];
//     x = 2;

//     while (x--) {
//       if (parallax[x]) {
//         pointer[x] = targetPointer[x] + decay * (prevPointer[x] - targetPointer[x]);
//       }
//     }

//     return updateFn(pointer);
//   }

//   function pointerOnTarget(targetPointer, prevPointer, threshold, decay, parallax, targetFn, updateFn) {
//     // Don't bother updating if the pointer hasn't changed.
//     if (targetPointer[0] === prevPointer[0] && targetPointer[1] === prevPointer[1]) {
//       return;
//     }

//     return updateFn(targetPointer);
//   }

//   function unport(elem, events, winEvents) {
//     elem.off(events).removeData('parallax_port');
//     win.off(winEvents);
//   }

//   function unparallax(node, port, events) {
//     port.elem.off(events);

//     // Remove this node from layers
//     port.layers = port.layers.not(node);

//     // If port.layers is empty, destroy the port
//     if (port.layers.length === 0) {
//       unport(port.elem, port.events, port.winEvents);
//     }
//   }

//   function unstyle(parallax) {
//     var css = {};

//     if (parallax[0]) {
//       css.left = '';
//       css.marginLeft = '';
//     }

//     if (parallax[1]) {
//       css.top = '';
//       css.marginTop = '';
//     }

//     elem.css(css);
//   }

//   jQuery.fn.parallax = function(o){
//     var options = jQuery.extend({}, jQuery.fn.parallax.options, o),
//         args = arguments,
//         elem = options.mouseport instanceof jQuery ?
//           options.mouseport :
//           jQuery(options.mouseport) ,
//         port = getData(elem, 'parallax_port', portData),
//         timer = port.timer;

//     return this.each(function(i) {
//       var node      = this,
//           elem      = jQuery(this),
//           opts      = args[i + 1] ? jQuery.extend({}, options, args[i + 1]) : options,
//           decay     = opts.decay,
//           size      = layerSize(elem, opts.width, opts.height),
//           origin    = layerOrigin(opts.xorigin, opts.yorigin),
//           px        = layerPx(opts.xparallax, opts.yparallax),
//           parallax  = layerParallax(opts.xparallax, opts.yparallax, px),
//           offset    = layerOffset(parallax, px, origin, size),
//           position  = layerPosition(px, origin),
//           pointer   = layerPointer(elem, parallax, px, offset, size),
//           pointerFn = pointerOffTarget,
//           targetFn  = targetInside,
//           events = {
//             'mouseenter.parallax': function mouseenter(e) {
//               pointerFn = pointerOffTarget;
//               targetFn = targetInside;
//               timer.add(frame);
//               timer.start();
//             },
//             'mouseleave.parallax': function mouseleave(e) {
//               // Make the layer come to rest at it's limit with inertia
//               pointerFn = pointerOffTarget;
//               // Stop the timer when the the pointer hits target
//               targetFn = targetOutside;
//             }
//           };

//       function updateCss(newPointer) {
//         var css = layerCss(parallax, px, offset, size, position, newPointer);
//         elem.css(css);
//         pointer = newPointer;
//       }

//       function frame() {
//         pointerFn(port.pointer, pointer, port.threshold, decay, parallax, targetFn, updateCss);
//       }

//       function targetInside() {
//         // Pointer hits the target pointer inside the port
//         pointerFn = pointerOnTarget;
//       }

//       function targetOutside() {
//         // Pointer hits the target pointer outside the port
//         timer.remove(frame);
//       }


//       if (jQuery.data(node, 'parallax')) {
//         elem.unparallax();
//       }

//       jQuery.data(node, 'parallax', {
//         port: port,
//         events: events,
//         parallax: parallax
//       });

//       port.elem.on(events);
//       port.layers = port.layers? port.layers.add(node): jQuery(node);

//       /*function freeze() {
//         freeze = true;
//       }

//       function unfreeze() {
//         freeze = false;
//       }*/

//       /*jQuery.event.add(this, 'freeze.parallax', freeze);
//       jQuery.event.add(this, 'unfreeze.parallax', unfreeze);*/
//     })
//   };

//   jQuery.fn.unparallax = function(bool) {
//     return this.each(function() {
//       var data = jQuery.data(this, 'parallax');

//       // This elem is not parallaxed
//       if (!data) { return; }

//       jQuery.removeData(this, 'parallax');
//       unparallax(this, data.port, data.events);
//       if (bool) { unstyle(data.parallax); }
//     });
//   };

//   jQuery.fn.parallax.options = options;

//   // Pick up and store mouse position on document: IE does not register
//   // mousemove on window.
//   doc.on('mousemove.parallax', function(e){
//     mouse = [e.pageX, e.pageY];
//   });
// }(jQuery));
// $(document).ready(function(){
//   if ($(window).width() > 960) {
//   $('.home__layer-img--1 ').parallax({
//     mouseport: $("#port"),
//       xparallax:     "70px",
//       yparallax:     "80px",
//       xorigin:        0.1,
//       yorigin:        0.1,
//       decay:         0.95,
//       frameDuration: 15
//   });
//   $('.home__layer-img--2 ').parallax({
//     mouseport: $("#port"),
//       xparallax:     "180px",
//       yparallax:     "200px",
//       xorigin:        0.2,
//       yorigin:        0.3,
//       decay:         0.95,
//       frameDuration: 5
//   });
//   $('.home__layer-img--4 ').parallax({
//       mouseport: $("#port"),
//       xparallax:     "60px",
//       yparallax:     "90px",
//       xorigin:        0.15,
//       yorigin:        0.7,
//       decay:         0.95,
//       frameDuration: 10
//   });
//   $('.home__layer-img--5 ').parallax({
//       mouseport: $("#port"),
//       xparallax:     "70px",
//       yparallax:     "80px",
//       xorigin:        0.9,
//       yorigin:        0.1,
//       decay:         0.95,
//       frameDuration: 15
//   });
//   $('.home__layer-img--3 ').parallax({
//       mouseport: $("#port"),
//       xparallax:     "60px",
//       yparallax:     "60px",
//       xorigin:        0.03,
//       yorigin:        0.55,
//       decay:         0.95,
//       frameDuration: 15
//   });
//   $('.home__layer-img--6 ').parallax({
//       mouseport: $("#port"),
//       xparallax:     "180px",
//       yparallax:     "200px",
//       xorigin:        0.8,
//       yorigin:        0.3,
//       decay:         0.95,
//       frameDuration: 5
//   });
//   $('.home__layer-img--7 ').parallax({
//       mouseport: $("#port"),
//       xparallax:     "60px",
//       yparallax:     "90px",
//       xorigin:        0.85,
//       yorigin:        0.8,
//       decay:         0.95,
//       frameDuration: 10
//   });


// }
// });


let parallaxBox = document.getElementById('port')

if (parallaxBox) {
  //set all your el`s #id
  let elements = [
    {id: 'l1'},
    {id: 'l2'}, 
    {id: 'l3'}, 
    {id: 'l4'}, 
    {id: 'l5'},
    {id: 'l6'},
    {id: 'l7'},
    
  ]
  
  let speeds = [25, 15, 30, 65, 40, 25, 15, 30, 65, 40, 25, 15, 30, 65, 40]  
  
  //check window width . It`s not available on mobile devices
  elements.forEach((el, i) => {
    let nodeEl = document.getElementById(el.id)
    if (!nodeEl) return
    //left and top position for every element

    el.left = nodeEl.offsetLeft
    el.top = nodeEl.offsetTop
   
  })
  if (1200 < window.outerWidth) {
    
    parallaxBox.onmousemove = function (event) {
      event = event || window.event
      
      let x = event.clientX - parallaxBox.offsetLeft
      let y = event.clientY - parallaxBox.offsetTop
      
      elements.forEach((el, i) => {
        
        mouseParallax(el.id, el.left, el.top, x, y, speeds[i])
      })
    }
  }
    /**
   * 
   * @param {string} id id of element
   * @param {number} left left position
   * @param {number} top top position
   * @param {*} mouseX cursor positon-x
   * @param {*} mouseY cursor positon-x
   * @param {number} speed el speed
   */
  function mouseParallax(id, left, top, mouseX, mouseY, speed) {
    var obj = document.getElementById(id)
    if (!obj) return 
    let parentObj = obj.parentNode.parentNode.parentNode
    let containerWidth = parseInt(parentObj.offsetWidth)
    let containerHeight = parseInt(parentObj.offsetHeight)
    obj.style.left = `${left - (((mouseX - (parseInt(obj.offsetWidth) / 10 + left)) / containerWidth) * speed)}px`
    obj.style.top = `${top - (((mouseY - (parseInt(obj.offsetHeight) / 10 + top)) / containerHeight) * speed)}px`
  } 
}



$(document).on('preloading-finished', function() {
  if ($(window).width() < 410) {
        var divWrap = $(".numeric");
        var divContent = $(".numeric__list");
        var scrollto = (divContent.width() - divWrap.width()) / 2 + 3 ;
       $(".slider-wrapper__numeric").scrollLeft(scrollto);
  }
})


// WEBPACK FOOTER //
// ./src/js/main.js